/* CBD HUT — hydrate secondary hover images on product cards (desktop only)
   Keeps mobile bandwidth low by NOT inserting the secondary <img> unless hover is possible.
*/
(() => {
  const canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!canHover) return;

  const hydrate = (mediaEl) => {
    if (!mediaEl || mediaEl.dataset.cbhSecondaryHydrated === '1') return;

    const tpl = mediaEl.querySelector('template[data-cbh-secondary-image]');
    if (!tpl) return;

    const img = tpl.content && tpl.content.querySelector && tpl.content.querySelector('img');
    if (!img) return;

    // Clone the <img> into the live DOM so the browser loads it only when needed
    mediaEl.appendChild(img.cloneNode(true));
    tpl.remove();

    mediaEl.dataset.cbhSecondaryHydrated = '1';
  };

  // Event delegation: works for section renders + dynamically injected cards
  document.addEventListener(
    'pointerover',
    (e) => {
      // Only react to real mouse hover (not touch/pen)
      if (e.pointerType && e.pointerType !== 'mouse') return;

      const mediaEl = e.target.closest('.card__media .media--hover-effect');
      if (!mediaEl) return;

      hydrate(mediaEl);
    },
    { passive: true, capture: true }
  );
})();
